module.exports = {
  "country": "YU",
  "artist": "Daniel",
  "song": "Dzuli",
  "year": "1983",
  "place": "4",
  "spotify": "7eGNaMxGWbhDXipyGUtloX"
};